var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7393 11.1469L22.7573 10.8243L24.0003 8L25.2433 10.8243L28.2613 11.1469L26.0073 13.2042L26.6392 16.2216L24.0003 14.68L21.3614 16.2216L21.9933 13.2042L19.7393 11.1469Z",
    fill: "url(#paint0_linear_3708_7061)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.982 22.7152L35.739 19.8909L34.496 22.7152L31.4781 23.0379L33.732 25.0951L33.1001 28.1125L35.739 26.5709L38.378 28.1125L37.7461 25.0951L40 23.0379L36.982 22.7152Z",
    fill: "url(#paint1_linear_3708_7061)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.504 22.7153L12.261 19.891L11.018 22.7153L8 23.0379L10.2539 25.0952L9.62203 28.1126L12.261 26.571L14.8999 28.1126L14.268 25.0952L16.5219 23.0379L13.504 22.7153Z",
    fill: "url(#paint2_linear_3708_7061)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2431 34.6028L24.0001 31.7784L22.7571 34.6028L19.7391 34.9254L21.993 36.9826L21.3611 40L24.0001 38.4584L26.639 40L26.0071 36.9826L28.2611 34.9254L25.2431 34.6028Z",
    fill: "url(#paint3_linear_3708_7061)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5217 31.3639L14.5397 31.0413L15.7827 28.217L17.0257 31.0413L20.0437 31.3639L17.7897 33.4212L18.4216 36.4385L15.7827 34.897L13.1438 36.4385L13.7757 33.4212L11.5217 31.3639Z",
    fill: "url(#paint4_linear_3708_7061)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0257 14.396L15.7827 11.5717L14.5397 14.396L11.5217 14.7187L13.7757 16.7759L13.1438 19.7933L15.7827 18.2517L18.4216 19.7933L17.7897 16.7759L20.0437 14.7187L17.0257 14.396Z",
    fill: "url(#paint5_linear_3708_7061)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9567 31.3639L30.9747 31.0413L32.2177 28.217L33.4607 31.0413L36.4787 31.3639L34.2247 33.4212L34.8566 36.4385L32.2177 34.897L29.5788 36.4385L30.2107 33.4212L27.9567 31.3639Z",
    fill: "url(#paint6_linear_3708_7061)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4607 14.396L32.2177 11.5717L30.9747 14.396L27.9567 14.7187L30.2107 16.7759L29.5788 19.7933L32.2177 18.2517L34.8566 19.7933L34.2247 16.7759L36.4787 14.7187L33.4607 14.396Z",
    fill: "url(#paint7_linear_3708_7061)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3708_7061",
    x1: 8,
    y1: 8,
    x2: 38.9564,
    y2: 40.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEu);
export default __webpack_public_path__ + "static/media/EU.6becf58b759f270f024afb9fac3bfb86.svg";
export { ForwardRef as ReactComponent };